import React, { useState, useCallback } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

function getTime() {
  return new Date().getTime();
}

export function RsaVisibilitySensor(props) {
  const [showElement, setShowElement] = useState(true);
  const [lastToggleTime, setLastToggleTime] = useState(getTime());

  const { partialVisibility, scrollCheck, scrollDelay, intervalDelay, visibleElement, skeletonElement, selectedCategoryLoading } = props;

  // Toggle between skeleton UI and real element
  // Show real element when toggle check is triggered within 100ms to
  // prevent a jitter effect in situations where skeleton UI height is
  // different from real element height
  const onChangeCallback = useCallback(
    isVisible => {
      if (isVisible === showElement) {
        return;
      }
      const newToggleTime = getTime();
      const diff = newToggleTime - lastToggleTime;
      if (diff > 100) {
        setShowElement(isVisible);
      } else {
        setShowElement(true);
      }
      setLastToggleTime(newToggleTime);
    },
    [lastToggleTime, showElement]
  );

  return (
    <VisibilitySensor
      onChange={onChangeCallback}
      partialVisibility={partialVisibility || true}
      scrollCheck={scrollCheck || true}
      intervalDelay={intervalDelay || 0}
      scrollDelay={scrollDelay || 0}
    >
      {({ isVisible }) => ((selectedCategoryLoading && isVisible) || !showElement ? skeletonElement : visibleElement)}
    </VisibilitySensor>
  );
}

export default RsaVisibilitySensor;
